"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clienteConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const clienteConverter = {
    toFirestore(cliente) {
        const obj = cliente;
        const buscableExactoPor = [];
        // if (cliente.nombreComercial != null && cliente.nombreComercial != "")
        //   buscableExactoPor.push(cliente.nombreComercial);
        // if (cliente.razonSocial != null && cliente.razonSocial != "") buscableExactoPor.push(cliente.razonSocial);
        if (cliente.documento != null && cliente.documento != "")
            buscableExactoPor.push(cliente.documento);
        if (cliente.nombreComercial != null &&
            cliente.nombreComercial != "" &&
            cliente.razonSocial != null &&
            cliente.razonSocial != "" &&
            cliente.nombreComercial != cliente.razonSocial) {
            buscableExactoPor.push(`${cliente.nombreComercial} - ${cliente.razonSocial}`);
        }
        else {
            if (cliente.nombreComercial != "" && cliente.nombreComercial != null) {
                buscableExactoPor.push(cliente.nombreComercial);
            }
            if (cliente.razonSocial != "" && cliente.razonSocial != null) {
                buscableExactoPor.push(cliente.razonSocial);
            }
        }
        if (buscableExactoPor.length > 0) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({ buscableParcialPor: buscableExactoPor, buscableExactoPor: [] });
        }
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            tipoDocumento: data.tipoDocumento,
            documento: data.documento,
            razonSocial: data.razonSocial,
            pais: data.pais,
            nombreComercial: data.nombreComercial,
            direccion: data.direccion,
            localidad: data.localidad,
            departamento: data.departamento,
            direccionEntrega: data.direccionEntrega,
            descuento: data.descuento,
            emails: data.emails,
            mailDgi: data.mailDgi,
            mailCopiaXml: Array.isArray(data.mailCopiaXml) ? data.mailCopiaXml : data.mailCopiaXml ? [data.mailCopiaXml] : [],
            vendedorId: data.vendedorId,
            rubroServiciosVentaId: data.rubroServiciosVentaId,
            listaPrecioServicios: data.listaPrecioServicios,
            listaPrecioProductos: data.listaPrecioProductos,
            formaDePago: data.formaDePago,
            activo: data.activo,
            campoExtra: data.campoExtra ?? {},
            saldoCuentas: data.saldoCuentas ?? {},
            topeCuentas: data.topeCuentas ?? {},
            buscablePor: data.buscablePor,
            claveAnalisisDeuda: data.claveAnalisisDeuda ?? "",
            comentarios: data.comentarios
        };
    }
};
exports.clienteConverter = clienteConverter;
